var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dumbapp-confirmation-message"},[_c('div',{staticClass:"material-icons message-icon"},[_vm._v("comment")]),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }